export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  'https://4eeq3jtica.execute-api.ap-south-1.amazonaws.com/mahasuchi/api';

export const SUPPORT_EMAIL = 'hello@zameenmahiti.com';
export const BRAND = 'Zameenmahiti';

export const REPORT_FEE = 1199;
export const GST = 0.18;
export const REPORT_TOTAL = Number((REPORT_FEE * (1 + GST)).toFixed(2));

const KEYS = {
  token: 'zm_customer_token',
  lead: 'zm_lead',
  records: 'zm_records',
  ctx: 'zm_ctx',
  payToken: 'zm_payment_token',
};

export const getToken = () =>
  sessionStorage.getItem(KEYS.token) || localStorage.getItem(KEYS.token) || '';

export const setToken = (t) => {
  const v = String(t || '').trim();
  if (!v) return;
  sessionStorage.setItem(KEYS.token, v);
  localStorage.setItem(KEYS.token, v);
};

export const apiFetch = (url, opts = {}) =>
  fetch(url, {
    credentials: 'include',
    ...opts,
    headers: {
      ...(opts.headers || {}),
      ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
    },
  });

export const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export const leadBackoff = (i) => Math.min(800 * 1.65 ** Math.min(i, 16), 25000);

export const save = (key, val) => {
  const s = typeof val === 'string' ? val : JSON.stringify(val);
  sessionStorage.setItem(key, s);
  localStorage.setItem(key, s);
};

export const load = (key, fallback = '') =>
  sessionStorage.getItem(key) || localStorage.getItem(key) || fallback;

export const clearPay = () => {
  [KEYS.records, KEYS.ctx, KEYS.payToken].forEach((k) => {
    sessionStorage.removeItem(k);
    localStorage.removeItem(k);
  });
};

export const K = KEYS;
